import { AxiosError } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';

import { requesterMobileIdentify } from '@app/store/transport-layer/identityaccess/users/mobile-identify';

const useRequesterMobileIdentification = (
  options?: UseMutationOptions<unknown, AxiosError, string>
) => {
  return useMutation<unknown, AxiosError, string>(
    (impUid) =>
      requesterMobileIdentify({
        impUid,
      }),
    options
  );
};
export default useRequesterMobileIdentification;
